import { SVGProps } from 'react';

const Strategy = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M9.099 2.256q.054.008.08.015c.032.007.06.015.076.02q.054.017.108.037c.073.026.171.063.284.107.228.087.55.214.92.358.748.29 1.723.665 2.68.999a.75.75 0 0 1-.494 1.416 83 83 0 0 1-2.541-.945l.5 1.5a.75.75 0 0 1-.318.876L6.902 8.787a.25.25 0 0 0 .131.463h2.968a.75.75 0 0 1 .709.995L8.98 15.25h6.175l.096-4.267a.75.75 0 0 1 1.499.034l-.1 4.47 1.132.567a1.75 1.75 0 0 1 .968 1.564V20a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75v-2.382a1.75 1.75 0 0 1 .968-1.564l1.085-.544 1.645-4.76H7.033A1.75 1.75 0 0 1 5.35 9.477a1.75 1.75 0 0 1 .649-1.888l.118-.08 2.984-1.836-.812-2.436a.752.752 0 0 1 .576-.974c.12-.022.216-.01.234-.007m-2.21 15.139a.25.25 0 0 0-.102.092.25.25 0 0 0-.037.131v1.632h10.5v-1.632a.25.25 0 0 0-.139-.223l-1.289-.645H8.178zM17 3.25a.75.75 0 0 1 .75.75A1.25 1.25 0 0 0 19 5.25a.75.75 0 0 1 0 1.5A1.25 1.25 0 0 0 17.75 8a.75.75 0 0 1-1.5 0A1.25 1.25 0 0 0 15 6.75a.75.75 0 0 1 0-1.5A1.25 1.25 0 0 0 16.25 4a.75.75 0 0 1 .75-.75"
    />
  </svg>
);

export default Strategy;
